@if (columnsConf$ | async; as conf) {
  <div class="layout-col full">
    <div class="flex layout-col gap-xl">
      <app-item-property-definition-organizer class="flex" [(properties)]="conf.columnDefinitions">
      </app-item-property-definition-organizer>
    </div>
  </div>
}
